module.exports = __webpack_public_path__ + "img/pencil-filter-left_jp.02c6474.jpg";